module.exports = __webpack_public_path__ + "img/word.ae1390c7.png";